import type { PaywallCustomization } from "@circle-react/types";
import { Typography } from "@circleco/compass/components/Typography";

import { ScopedThemeProvider } from "@/react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/Offer/ScopedThemeProvider";
import { getBestFontColor } from "@/react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PaywallCustomization/PriceCallout/getBestFontColor";
import { DETAILED_BACKGROUND_COLOR } from "@/react/helpers/paywallCustomizationHelpers";
import { APPEARANCE } from "@/react/providers/Theme";

export const UpgradeMediaBlocks = ({
  customization,
}: {
  customization?: PaywallCustomization;
}) => {
  const properties = customization?.media_block_properties;
  const blocks = properties?.media_blocks ?? [];
  if (!properties?.enabled || blocks.length === 0) return null;

  return blocks.map((block, index) => {
    const backgroundColor = block.background_color || DETAILED_BACKGROUND_COLOR;
    const appearance =
      getBestFontColor(backgroundColor) === "#FFFFFF"
        ? APPEARANCE.DARK
        : APPEARANCE.LIGHT;

    return (
      <ScopedThemeProvider
        key={block.id ?? `${block.title}-${index}`}
        appearance={appearance}
      >
        <article
          className="w-full px-5 py-6 md:px-10 md:py-12"
          data-testid="upgrade-authored-media-block"
          style={{ backgroundColor }}
        >
          <div className="mx-auto flex w-full flex-col items-center gap-y-5 md:w-[768px]">
            {(block.title || block.description) && (
              <div className="flex w-full flex-col items-center gap-y-1 text-center">
                {block.title && (
                  <Typography variant="heading-lg">{block.title}</Typography>
                )}
                {block.description && (
                  <Typography variant="body-md" color="secondary">
                    {block.description}
                  </Typography>
                )}
              </div>
            )}
            {block.cover?.url && (
              <img
                className="w-full rounded-2xl object-cover"
                src={block.cover.url}
                alt=""
                loading="lazy"
              />
            )}
          </div>
        </article>
      </ScopedThemeProvider>
    );
  });
};
